import { render, staticRenderFns } from "./FormVideoVolume.vue?vue&type=template&id=ff4d5d5a&"
import script from "./FormVideoVolume.vue?vue&type=script&lang=js&"
export * from "./FormVideoVolume.vue?vue&type=script&lang=js&"
import style0 from "./FormVideoVolume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports